export const BRAND = {
  productName: 'Sapyon AI',
  productTagline: 'Retail Ops',
} as const;
